import React from "react";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import Button from "components/Elements/Button/Button.js";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";

const OnlySubscribersAlert = ({ title = null, text }) => {
  const { getTextByKey } = useContent();
  return (
    <div className="branding-only-business-alert">
      <div className="only-business-content">
        <div className="only-business-icon">
          <Image name="exclamation-icon" ext="svg" alt="" title="" />
        </div>
        <div className="only-business-text">
          <span className="bold-text">
            {getTextByKey(title ? title : "branding-only-subscriber-note")}
          </span>
          <br></br>
          <span className="simple-text">{getTextByKey(text)}</span>
        </div>
      </div>
      <div className="only-business-link">
        <Button className="new-button">
          <LinkToNewTab isNewTab page={"plans"}>
            {getTextByKey("see-plans")}
          </LinkToNewTab>
        </Button>
      </div>
    </div>
  );
};

export default OnlySubscribersAlert;
